<span mat-button mat-dialog-close class="close-btn-modal material-icons">close</span>
<div class="dialoghead ng-star-inserted">
  <h1 class="mat-mdc-dialog-title mdc-dialog__title ng-star-inserted">Training Settings</h1>
</div>
<form  (ngSubmit)="trainingsettings()"  name="trainingsettingsForm" [formGroup]="trainingsettingsForm">
  <section class="example-section">
      <mat-checkbox class="example-margin" formControlName="sequential_training_enabled"       
      [checked]="trainingFlag">Sequential Training Enabled</mat-checkbox>      
  </section>
  <div class="mat-mdc-dialog-actions"><button mat-button>Submit</button></div>
</form>